import React, { useEffect } from "react";
import styles from "./styles.module.scss";
import Loader from "../loader/Loader";
import { API_RESULT } from "src/utils/enums";
import { __DEV__, sentPostMessage } from "src/utils/utils";

interface SuccessProps {
  className?: string;
}

const Success: React.FC<SuccessProps> = ({ className }) => {
  useEffect(() => {
    __DEV__ && console.log("$$$ Hello from Success Iframe");
    sentPostMessage({
      status: API_RESULT.SUCCEEDED,
    });
  }, []);

  return (
    <div className={styles.successContainer}>
      <div className={styles.loaderWrapper}>
        <Loader fullHeight={false} />
      </div>
    </div>
  );
};

export default Success;
